// ======================================================================
// File Name       : ServiceNotificationDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Col, Button } from 'react-bootstrap';
import Header from '../../components/Header';
import * as ServiceAction from '../../actions/ServiceAction';
import ServiceNoticeDetailInfo from '../../components/service/serviceNotification/ServiceNoticeDetailInfo';
import ServiceNoticeDetailUserList from '../../components/service/serviceNotification/ServiceNoticeDetailUserList';
import {
  SERVICE_NOTIFICATION_EDIT,
  SERVICE_NOTIFICATION_DETAIL,
} from '../../constants/PathConstants';
import { SELECT_TARGET_DATA, MODE, SUPER_USER_SECERN_ID } from '../../constants/index';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { SERVICE_USER_TYPE, RELEASE_TARGET } from '../../constants/ServiceConstant';
import * as FunctionConstants from '../../constants/FunctionConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';
import { isSuperUser } from '../../utils';
import { checkAuthorSuperuser } from '../../utils/PageUtils';

class ServiceNotificationDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      canAccess: false,
    };
    this.getServiceNoticeDetail = this.getServiceNoticeDetail.bind(this);
    this.deleteServiceNotice = this.deleteServiceNotice.bind(this);
    this.onDeleteDialogOk = this.onDeleteDialogOk.bind(this);
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind(this);
    this.goToEdit = this.goToEdit.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      this.props.history.goBack();
    }
    const canAccess = canAccessRoute(FunctionConstants.SERVICE_NOTIFICATION_EDIT);
    this.getServiceNoticeDetail(match.params.id, canAccess);
  }

  componentWillUnmount() {
    this.props.dispatch(ServiceAction.resetServiceNoticeDetail());
  }

  getServiceNoticeDetail(noticeSecernId, canAccess) {
    const param = {};
    param.selectTargetData = SELECT_TARGET_DATA.DATA;
    param.searchInfo = { noticeList: [noticeSecernId] };
    this.setState(
      {
        canAccess,
      },
      () => {
        this.props.dispatch(ServiceAction.getServiceNoticeDetail(param));
      },
    );
  }

  deleteServiceNotice() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      return;
    }
    this.setState({
      showDeleteModal: true,
    });
  }

  onDeleteDialogOk() {
    const { match } = this.props;
    const noticeSecernId = match.params.id;
    const param = {};
    param.editType = MODE.DELETE_MODE;
    param.noticeInfo = { noticeSecernId };
    this.setState(
      {
        showDeleteModal: false,
      },
      () => {
        this.props.dispatch(ServiceAction.deleteServiceNotification(param)).then((error) => {
          if (!error) {
            this.props.history.goBack();
          }
        });
      },
    );
  }

  onDeleteDialogCancel() {
    this.setState({
      showDeleteModal: false,
    });
  }

  goToEdit() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      return;
    }
    const path = SERVICE_NOTIFICATION_EDIT.replace(':id', match.params.id);
    this.props.history.push(path);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const {
      serviceNoticeDetail,
      serviceDetailUserList,
      userSecernId,
      displayUserType,
      representationUserSecernId,
    } = this.props;
    let releaseTarget = RELEASE_TARGET.ALL;
    if (serviceNoticeDetail) {
      releaseTarget = serviceNoticeDetail.releaseTarget;
    }
    // Step9.0.0 START
    // Step10.0.0 START
    const isEditableNotice = userSecernId === serviceNoticeDetail.authorSecernId || checkAuthorSuperuser(
      serviceNoticeDetail.authorSecernId,
      isSuperUser(displayUserType),
      representationUserSecernId
    );
    // Step10.0.0 END
    // Step9.0.0 END
    return (
      <div>
         <CustomLink
          className="margin-right-7 url-list"
          to={Path.SERVICE_NOTIFICATION_LIST}
          text="お知らせ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="サービス向けお知らせ情報の詳細" />
        <ServiceNoticeDetailInfo {...serviceNoticeDetail} isDetail />
        {releaseTarget === RELEASE_TARGET.INDIVIDUAL && (
          <ServiceNoticeDetailUserList serviceDetailUserList={serviceDetailUserList} />
        )}
        {isEditableNotice && ( // Step9.0.0
          <Col sm={12} className="text-center margin-top-20">
            {this.state.canAccess && (
              <Button variant="primary" className="btn-96 margin-10" onClick={this.goToEdit}>
                編集
              </Button>
            )}
            {this.state.canAccess && (
              <Button
                variant="primary"
                className="btn-96 margin-10"
                onClick={this.deleteServiceNotice}
              >
                削除
              </Button>
            )}
          </Col>
        )}
        <DialogConfirm
          showModal={this.state.showDeleteModal}
          onCancel={this.onDeleteDialogCancel}
          content={MessageTemplate.MSG_DEL_SERVICE_NOTICE}
          onOK={this.onDeleteDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceNoticeDetail, serviceDetailUserList } = state.service;
  const { userSecernId, displayUserType, representationUserSecernId } = state.authed.authedUser.userInfo; // Step9.0.0
  return {
    serviceNoticeDetail,
    serviceDetailUserList,
    // Step9.0.0 START
    userSecernId,
    displayUserType,
    // Step9.0.0 END
    representationUserSecernId,
  };
};

export default connect(mapStateToProps)(ServiceNotificationDetailContainer);
